import { notEditable } from '../../../utils/constants';

export const deactivateEditModeAction = (state) => {
  state.questionList.forEach((question) => {
    if (!notEditable.includes(question.internal_name)) {
      question.editMode = false;
    }
  });
};
